const MODEL_NAME = 'service'
export default [
  {
    path: `/${MODEL_NAME}/messageCenter`,
    name: 'messageCenter',
    component: () =>
      import(/* webpackChunkName: "message-center" */ '@pages/service/messageCenter/index.vue')
  },
  {
    path: `/${MODEL_NAME}/messageCenterList`,
    name: 'messageCenterList',
    component: () =>
      import(/* webpackChunkName: "message-center" */ '@pages/service/messageCenterList/index.vue')
  }
]
